function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { padding } from '../util';
var TOKEN_REG = /(YYYY|YY|MMMM|MMM|MM|M|DDDD|DDD|DD|D|HH|H|hh|h|A|a|mm|m|ss|s|SSS|QQ|Q|WW|W|dddd|ddd|dd|d|.)/g;
export function tokenizer(format) {
  var result = [];
  var matched = TOKEN_REG.exec(format);

  while (matched != null) {
    result.push(matched[0]);
    matched = TOKEN_REG.exec(format);
  }

  return result;
}
export var CONVERTER_MAP = {};

function defaultConverter(num) {
  return num;
}

export function createNumberConverter(options) {
  var maxLength = options.maxLength,
      field = options.field,
      getter = options.getter,
      format = options.format,
      paddingFormat = options.paddingFormat,
      _options$converter = options.converter,
      converter = _options$converter === void 0 ? defaultConverter : _options$converter;

  if (format != null) {
    CONVERTER_MAP[format] = {
      formatToken: function formatToken(date, locale) {
        return String(getter(date, locale));
      },
      matchToken: function matchToken(str) {
        var reg = new RegExp("^(\\d{1,".concat(maxLength, "})"));

        if (reg.test(str)) {
          return RegExp.$1;
        }

        return false;
      },
      parseToken: function parseToken(str) {
        if (field == null) {
          return {};
        }

        return _defineProperty({}, field, converter(parseInt(str, 10), format));
      }
    };
  }

  if (paddingFormat != null) {
    CONVERTER_MAP[paddingFormat] = {
      formatToken: function formatToken(date, locale) {
        return padding(String(getter(date, locale)), maxLength);
      },
      matchToken: function matchToken(str) {
        var reg = new RegExp("^(\\d{".concat(maxLength, "})"));

        if (reg.test(str)) {
          return RegExp.$1;
        }

        return false;
      },
      parseToken: function parseToken(str) {
        if (field == null) {
          return {};
        }

        return _defineProperty({}, field, converter(parseInt(str, 10), paddingFormat));
      }
    };
  }
}
export function createEnumConverter(options) {
  var format = options.format,
      field = options.field,
      getter = options.getter,
      localeKey = options.localeKey;
  CONVERTER_MAP[format] = {
    formatToken: function formatToken(date, locale) {
      return locale[localeKey][getter(date)];
    },
    matchToken: function matchToken(str, locale) {
      var reg = new RegExp('^(' + locale[localeKey].join('|') + ')');

      if (reg.test(str)) {
        return RegExp.$1;
      }

      return false;
    },
    parseToken: function parseToken(str, locale) {
      var index = locale[localeKey].indexOf(str);

      if (field == null) {
        return {};
      }

      return _defineProperty({}, field, index);
    }
  };
}